export default function () {
    function setCookie({ name, value, expireDays, expireHours, expireMinutes, expireSeconds }) {
        let expireDate = new Date()
        if (expireDays) {
            expireDate.setDate(expireDate.getDate() + expireDays)
        }
        if (expireHours) {
            expireDate.setHours(expireDate.getHours() + expireHours)
        }
        if (expireMinutes) {
            expireDate.setMinutes(expireDate.getMinutes() + expireMinutes)
        }
        if (expireSeconds) {
            expireDate.setSeconds(expireDate.getSeconds() + expireSeconds)
        }

        document.cookie =
            name +
            '=' +
            value +
            ';domain=' +
            window.location.hostname +
            ';path=/' +
            ';expires=' +
            expireDate.toUTCString()
    }

    function deleteCookie(name) {
        setCookie({ name: name, value: '', expireSeconds: 1 })
    }

    function getCookie(cname) {
        const name = cname + '='
        const decodedCookie = decodeURIComponent(document.cookie)
        const ca = decodedCookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) == ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }
    return {
        getCookie,
        setCookie,
        deleteCookie
    }
}
